import merge from "lodash/merge";
import { apiBaseUrl, optimizeApiBaseUrl } from "../env";
import ES6Promise from "es6-promise";
import "whatwg-fetch";

ES6Promise.polyfill();

export const API_REQUEST = "API_REQUEST";
export const API_SUCCESS = "API_SUCCESS";
export const API_FAILURE = "API_FAILURE";
export const API_INVALID = "API_INVALID";
export const API_UNAUTHORIZED = "API_UNAUTHORIZED";

export function apiEndpoint(path) {
  return `${apiBaseUrl}/${path}`;
}
export function optimzieApiEndpoint(path) {
  return `${optimizeApiBaseUrl}/${path}`;
}

function request(dispatch, type, handler) {
  dispatch({
    type: [API_REQUEST, type].join("."),
  });
  handler && handler();
}

function success(dispatch, type, payload, handler) {
  dispatch({
    type: [API_SUCCESS, type].join("."),
    payload: payload,
  });
  handler && handler(payload);
}

function failure(dispatch, type, payload, handler) {
  dispatch({
    type: [API_FAILURE, type].join("."),
    payload: payload,
  });
  handler && handler();
}

function invalid(dispatch, type, payload, handler) {
  dispatch({
    type: [API_INVALID, type].join("."),
    payload: payload,
  });
  handler && handler();
}

function unauthorized(dispatch, type, payload, handler) {
  dispatch({
    type: [API_UNAUTHORIZED, type].join("."),
    payload: payload,
  });
  handler && handler();
}

function headers(state) {
  const token = state.app && state.app.token ? state.app.token : "";
  return {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: token,
    /*"Cache-Control": "no-cache",*/
    /*"max-age": 0,*/
  };
}

function handleFailure(dispatch, response, type, handlers, json = {}) {
  if (response.status === 401) {
    unauthorized(dispatch, type, json, handlers.unauthorized);
  } else if (response.status === 422) {
    invalid(dispatch, type, json, handlers.invalid);
  } else {
    failure(dispatch, type, json, handlers.failure);
  }
}

function flattenObj(x, path) {
  let result = [];

  path = path || [];
  Object.keys(x).forEach((key) => {
    if (!x.hasOwnProperty(key)) return;

    let newPath = path.slice();
    newPath.push(key);

    let vals = [];
    if (typeof x[key] === "object") {
      vals = flattenObj(x[key], newPath);
    } else {
      vals.push({
        path: newPath,
        val: x[key],
      });
    }
    vals.forEach((obj) => result.push(obj));
  });

  return result;
}

export function toQueryString(obj) {
  let parts = flattenObj(obj);

  // convert to array notation:
  parts = parts.map((varInfo) => {
    if (varInfo.path.length === 1) varInfo.path = varInfo.path[0];
    else {
      let first = varInfo.path[0];
      let rest = varInfo.path.slice(1);
      varInfo.path = first + "[" + rest.join("][") + "]";
    }
    return varInfo;
  });

  // join the parts to a query-string url-component
  let queryString = parts
    .map(
      (varInfo) =>
        encodeURIComponent(varInfo.path) +
        "=" +
        encodeURIComponent(varInfo.val),
    )
    .join("&");
  return queryString;
}

export function callApi(
  dispatch,
  getState,
  type,
  endpoint,
  opt = {},
  handlers = {},
  isOptimizeApi = false,
) {
  let options = merge(
    {
      endpoint: isOptimizeApi
        ? optimzieApiEndpoint(endpoint)
        : apiEndpoint(endpoint),
      method: "GET",
      headers: headers(getState()),
    },
    opt,
  );

  request(dispatch, type, handlers.request);
  return fetch(options.endpoint, options)
    .then(function (response) {
      const contentType = response.headers.get("content-type");
      if (
        contentType &&
        (contentType.indexOf("image") >= 0 ||
          contentType.indexOf("stream") >= 0)
      ) {
        if (response.ok) {
          response.blob().then((body) => {
            success(dispatch, type, body, handlers.success);
          });
        }
      } else {
        const _response = null;
        const ContentType = response.headers.get("content-type");
        if (ContentType && ContentType.match(/application\/json/)) {
          _response = response.json();
        } else {
          _response = Promise.resolve(null);
        }
        return _response
          .then((json) => {
            if (response.ok) {
              success(dispatch, type, json, handlers.success);
              return Promise.resolve(json);
            } else {
              handleFailure(dispatch, response, type, handlers, json);
            }
          })
          .catch((error) => {
            if (response.ok) {
              success(dispatch, type, {}, handlers.success);
            } else {
              handleFailure(dispatch, response, type, handlers);
            }
          });
      }
    })
    .catch((error) => {
      handleFailure(dispatch, { status: 400 }, type, handlers);
    });
}



// WEBPACK FOOTER //
// ./src/actions/Api.js